import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { postOtp } from '../requests';
import type { PostOtpRequestType, PostOtpResponseType } from '../types';

export const usePostOtpQuery = (
  { bodyParams: { email, phone } }: PostOtpRequestType,
  options?: {
    enabled?: boolean;
    onError?: (error: unknown) => void;
    onSuccess?: (data: PostOtpResponseType['data']) => void;
  },
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.otpCode, { email, phone }],
    queryFn: () => postOtp({ bodyParams: { email, phone } }),
    ...options,
  });
